import { DivProps } from '@/domains/global';

export const SCENE_OPTION_MENU_ITEM_COMMON_CLASSNAME: DivProps['className'] =
  'flex w-full items-center justify-between rounded-sm p-2 text-sm text-gray-900 hover:bg-slate-100';
